import React, { memo } from "react";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = memo(function DataPoints({ dataPoints, isUserQa }) {
  if (!dataPoints || !dataPoints.length) return null;

  return (
    <div className="data-points">
      {dataPoints.map((dataPoint) => {
        return (
          <div key={dataPoint.label} className="data-point">
            <DataDisplay
              key={dataPoint.label}
              label={dataPoint.label}
              disableAnimation={isUserQa}
              value={dataPoint.count}
              type="money"
              decimal={dataPoint.decimal}
              currency={dataPoint?.currency}
            />
          </div>
        );
      })}
    </div>
  );
});
